import { useQuery } from "@tanstack/react-query";
import { tournamentApi } from "@bw/shared/api";
import type { PairingResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The caller's pairing INBOX for a draw (SLICE 1.4-d) — GET
 * /tournaments/draws/{id}/pairings/mine via tournamentApi.getMyPairings. Returns
 * the server's PairingResponse[] VERBATIM (newest-first, SERVER-SCOPED to the
 * token user); each pairing carries its own server-computed `viewer_role`
 * ("proposer" | "partner") and DISPLAY NAMES — the inbox renders names + the
 * role-driven affordance and NEVER derives the role client-side.
 *
 * Keyed by the draw id (pairingsMine(drawId)). A respond/propose mutation
 * invalidates that key so the inbox reflects the server's refetched truth.
 */
export function usePairingsMine(drawId: string) {
  return useQuery<PairingResponse[]>({
    queryKey: queryKeys.tournaments.pairingsMine(drawId),
    queryFn: () => tournamentApi.getMyPairings(drawId),
    enabled: Boolean(drawId),
  });
}
